'use client'

import classNames from 'classnames'

const ChevronIcon = ({ expanded }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={classNames('shrink-0 transition-transform duration-200', {
      'rotate-180': expanded,
    })}
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
)

export const Accordion = ({
  id,
  expanded,
  onChange,
  label,
  children,
  href,
  ariaCurrent,
  summaryClassName = 'text-[#1d252f]',
}) => {
  const hasChildren = children != null

  const handleClick = () => {
    if (hasChildren) {
      onChange?.(expanded ? null : id)
    }
  }

  const SummaryContent = (
    <div className="flex w-full items-center justify-between gap-2 px-4 py-2">
      <span className={classNames('font-bold', summaryClassName)}>{label}</span>
      {hasChildren && <ChevronIcon expanded={expanded} />}
    </div>
  )

  if (!hasChildren && href) {
    return (
      <div data-testid="accordion-item-link" className="">
        <a
          href={href}
          className="flex w-full cursor-pointer items-center justify-between gap-2 py-2 no-underline transition-colors hover:opacity-80"
          aria-controls={`panel-${id}-content`}
          aria-current={ariaCurrent}
          id={`panel-${id}-header`}
        >
          {SummaryContent}
        </a>
      </div>
    )
  }

  return (
    <div data-testid="accordion-item" className="">
      <button
        type="button"
        onClick={handleClick}
        className="flex w-full cursor-pointer items-center justify-between gap-2 border-0 bg-transparent p-0 text-left transition-colors hover:opacity-80"
        aria-expanded={expanded}
        aria-controls={`panel-${id}-content`}
        id={`panel-${id}-header`}
      >
        {SummaryContent}
      </button>
      <div
        id={`panel-${id}-content`}
        role="region"
        aria-labelledby={`panel-${id}-header`}
        className={classNames(
          'grid transition-[grid-template-rows] duration-300 ease-in-out',
          expanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        )}
      >
        <div className="overflow-hidden">
          <div className="pt-0">{children}</div>
        </div>
      </div>
    </div>
  )
}

export default Accordion
